// src/hooks/useApi.js
import { api } from '../api';

export const useApi = () => api;
